<template>
    <div class="usp">
        <div class="usp-content">
            <p class="usp-title">
                {{ t({ key: 'shared.why', suffix: ' Sembo' }) }}
            </p>

            <ul class="usp-list">
                <li v-for="(row, index) in visibleRows" :key="index" class="usp-list-item">
                    <Icon v-if="row.icon" :type="row.icon" :color="'primary'" />
                    <span>
                        <span>{{ t({ key: row.label }) }}</span>
                        <span v-if="row.value">
                            <Link
                                v-if="row.valuePrefix"
                                :href="row.valuePrefix"
                                :label="row.value" />
                            <span v-else>{{ row.value }}</span>
                        </span>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent } from 'vue';
    import { useStore } from '@/store';
    import { AnyProduct } from '@shared/interfaces/product';
    import { Type } from '@ui/components/Icon/Icon.interfaces';
    import { getMarketPhoneNumber } from '@shared/config/market/market.helpers';
    import { Market } from '@shared/config/market/market.models';
    import Icon from '@ui/components/Icon/Icon.vue';
    import Link from '@ui/components/Link/Link.vue';

    interface Row {
        visible: boolean;
        label: string;
        value?: string;
        valuePrefix?: string;
        icon: Type;
    }

    export default defineComponent({
        name: 'Usp',
        methods: { t },
        props: {
            hasLeaBank: Boolean,
            market: { type: Object as () => Market, required: true },
        },
        components: { Icon, Link },
        setup(props) {
            const store = useStore();
            const phoneNumber = computed(() => getMarketPhoneNumber(props.market, 'support'));

            const getRows = (): Row[] => {
                const hasHotel = store.state.cart?.data?.Products?.some(
                    (x: AnyProduct) => x.Type === 'Hotel'
                );

                return [
                    {
                        visible: hasHotel,
                        label: 'shared.price_guarantee_usp',
                        icon: 'Dollar',
                    },
                    {
                        visible: true,
                        label: 'shared.customer_satisfaction_usp',
                        icon: 'HappyCircle',
                    },
                    {
                        visible: true,
                        label: 'shared.customer_service_usp',
                        value: phoneNumber.value,
                        valuePrefix: `tel:${phoneNumber.value}`,
                        icon: 'Chat',
                    },
                    {
                        visible: true,
                        label: props.hasLeaBank
                            ? 'shared.secure_payment_usp_with_leabank'
                            : 'shared.secure_payment_usp',
                        icon: 'ShieldCheck',
                    },
                ];
            };

            const visibleRows = computed(() => getRows().filter((x) => x.visible));

            return {
                visibleRows,
            };
        },
    });
</script>

<style lang="scss">
    @forward 'Usp';
</style>
